import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { MatrixFilter } from '../common-interfaces-classes/MatrixFilter';

@Injectable({
  providedIn: 'root'
})
export class StatsMatrixHandlerService {

  constructor() { }

  // Event for applying matrix filters - from person search listing to person search filter
  private matrixSelectionSubject: Subject<MatrixFilter> = new Subject();

  get matrixSelectionEvent(): Observable<MatrixFilter> {
    return this.matrixSelectionSubject.asObservable();
  }

  emitMatrixSelectionObject(matrixEventData: MatrixFilter) {
    this.matrixSelectionSubject.next(matrixEventData);
  }

  // from person search filter to person search listing
  private filterMatrixSubject: Subject<MatrixFilter> = new Subject();

  get filterMatrixEvent(): Observable<MatrixFilter> {
    return this.filterMatrixSubject.asObservable();
  }

  emitFilterMatrixObject(matrixEventData: MatrixFilter) {
    this.filterMatrixSubject.next(matrixEventData);
  }

}
